import React, { useState } from "react";
import { ChevronLeft, TaxiFrontFill } from "react-bootstrap-icons";
import AccardionItem from "../Accardion/AccardionItem/AccardionItem";
import Style from "./Accardion13.module.scss";
const Accardion13 = () => {
  const [openAll , setOpenAll]=useState(false)

  const ItemList = [
    // {
    //   id: "1",
    //   title: "درخواست پرداخت جدید",
    //   link: "/newpayreq",
    //   active: window.location.pathname === "/newpayreq",
    // },
    {
      id: "2",
      title: "همه درخواست های تاکسی",
      link: "/alltaxireq",
      active: window.location.pathname === "/alltaxireq",
    },

  ];

  let value = false;
  ItemList.forEach((element) => {
    if (element.active) {
      value = true;
    }
  });

  const openHandlerAll=()=>{
    if(openAll){
      setOpenAll(false)
    }
    else{
      setOpenAll(true)
    }
  }
  return (
    <div className={Style.componentHolder}>
      <div
        className={value || openAll ? Style.background : Style.accardionTitle}
        onClick={openHandlerAll}
      >
        <ChevronLeft />
        <div className={Style.right}>
          <p className={Style.accardionText}>تاکسی</p>
          <TaxiFrontFill />
        </div>
      </div>
      <div className={value ||openAll ? Style.inneraccardionContent : Style.hidden}>
        <AccardionItem accardonItem={ItemList && ItemList} />
      </div>
    </div>
  );
};

export default Accardion13;
